

















































import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReference, Reference } from "@/models/reference.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import RepairEstimateCreateStepper from "./RepairEstimateCreateStepper.vue";
import { IRepairEstimate } from "@/models/repair-estimate.entity";

enum RepairEstimateRejectSteps {
  START = "start",
  SEND_MAIL = "sendMail",
  SUCCESS = "success"
}

@Component({
  components: {
    RepairEstimateCreateStepper,
    ConfirmActionDialog,
    PreselectTemplateCard
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class RepairEstimateRejectDialog extends mixins(PermissionMixin) implements IDialog {
  readonly RepairEstimateRejectSteps = RepairEstimateRejectSteps;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop()
  hideButton!: boolean;

  @Prop()
  value!: IRepairEstimate;

  @Prop()
  sharedContent!: ISharedContent;

  isDialogActive = false;

  step = RepairEstimateRejectSteps.START;

  isRepairEstimateRejectDialogLoading = false;

  isSendLoading = false;

  get refs() {
    const refs: IReference[] = [];

    if (this.value.id) {
      refs.push(new Reference({ refId: this.value.id, refType: ResourceEnum.REPAIR_ESTIMATE }));
    }

    return refs;
  }

  get currentStep() {
    return this.steps.get(this.step);
  }

  get context() {
    return {
      repairEstimate: this.value,
      sharedContent: this.sharedContent ?? undefined,
      partner: this.partner,
      url: this.sharedContent ? { sharing: this.sharedContent?.url } : undefined
    };
  }

  get partner() {
    return PartnerModule.partner;
  }

  get steps() {
    return new Map([
      [
        RepairEstimateRejectSteps.START,
        {
          title: this.$t("repairEstimate.reject"),
          backText: $t("close"),
          nextText: $t("confirm"),
          loading: this.isRepairEstimateRejectDialogLoading,
          disabled: false,
          rightColor: "error",
          back: () => this.close(),
          next: () => this.reject()
        }
      ],
      [
        RepairEstimateRejectSteps.SEND_MAIL,
        {
          title: this.$t("repairEstimate.sendMail"),
          backText: $t("close"),
          nextText: $t("send"),
          loading: false,
          disabled: false,
          back: () => this.close(),
          next: () => this.send()
        }
      ],
      [
        RepairEstimateRejectSteps.SUCCESS,
        {
          title: this.$t("repairEstimate.success"),
          hideBack: true,
          nextText: $t("close"),
          loading: false,
          next: () => this.close()
        }
      ]
    ]);
  }

  open() {
    this.step = RepairEstimateRejectSteps.START;
    this.isDialogActive = true;
  }

  close() {
    this.step = RepairEstimateRejectSteps.START;
    this.isDialogActive = false;
  }

  async reject() {
    try {
      this.isRepairEstimateRejectDialogLoading = true;
      await this.value.reject();

      this.$toast.success("👍");
      this.step = RepairEstimateRejectSteps.SEND_MAIL;
    } catch (e) {
      handleError(e);
    } finally {
      this.isRepairEstimateRejectDialogLoading = false;
    }
  }

  async send() {
    this.isSendLoading = true;
    await this.templateCard?.send();
    this.step = RepairEstimateRejectSteps.SUCCESS;
    this.isSendLoading = false;
  }
}
